var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.column},[(_vm.showMenuButton)?_c('MenuButton'):_vm._e(),_vm._t("default"),_vm._l((_vm.navigationItems),function(navigationItem){return _c('NavigationIconItem',_vm._b({key:navigationItem.id,attrs:{"render-horizontally":_vm.renderHorizontally}},'NavigationIconItem',navigationItem,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }